import moment from 'moment';

export const correctivePreventiveInternal = {
    id: '',
    customerComplaintId: '',
    rootCauseType: '',
    rootCauseRemark: '',
    actionType: '',
    actionRemark: '',
    workDescription: '',
    evidence: '',
    picId: '',
    picName: '',
    picEmail: '',
    targetDate: moment().format('YYYY-MM-DD'),
  }
  
  export const customerComplaintInvestigationDetail = {
    id: '',
    customerComplaintId: '',
    question: '',
    memberId: '',
    responder: '',
    email: '',
    attachment: '',
    answeredAt: '',
  }